import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import SplashCursor from './SplashCursor';
import { FaWhatsapp, FaTelegramPlane, FaInstagram, FaFacebookF, FaYoutube } from 'react-icons/fa';
import './Terms.css'; // Reusing the premium styles
import './MainPage.css'; 
import Footer from './Footer';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="terms-page">
      <SplashCursor RAINBOW_MODE={false} COLOR="#A855F7" />

      {/* Navigation */}
      <header className="header">
        <div className="header-container">
          <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
            <img src="/images/Final Font Stocks4U1.png" alt="Stocks4U Logo" className="logo-text" style={{ width: '150px', height: 'auto' }} />
          </div>
          
          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            <a href="/" onClick={() => setIsMobileMenuOpen(false)}>Home</a>
            <a href="/#features" onClick={() => setIsMobileMenuOpen(false)}>Features</a>
            <a href="/#pricing" onClick={() => setIsMobileMenuOpen(false)}>Pricing</a>
            <a href="/about" onClick={() => setIsMobileMenuOpen(false)}>About</a>
            <a href="/#contact" onClick={() => setIsMobileMenuOpen(false)}>Contact</a>
          </nav>

          <button
            className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          
          <div className="header-buttons">
            <button className="login-btn" onClick={() => navigate('/login')}>Login</button>
            <button className="get-started-btn" onClick={() => navigate('/login')}>Get Started</button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="terms-hero-new">
        <div className="terms-hero-bg-glow"></div>
        <div className="terms-hero-content">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="terms-title-hero"
          >
            <span className="gradient-text-hero">Privacy Policy</span>
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="terms-hero-desc"
          >
            How we collect, use, and protect your information.
          </motion.p>
        </div>
      </section>

      {/* Content Section */}
      <section className="terms-content-section">
        <div className="container terms-container">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="terms-glass-card"
          >
            <div className="terms-header-info">
              <p><strong>Effective Date:</strong> <span className="highlight">[Effective Date]</span></p>
              <p><strong>Website/App Name:</strong> Stocks4U</p>
              <p><strong>Owned & Operated By:</strong> <span className="highlight">[Your Company Name]</span></p>
              <p><strong>Contact Email:</strong> <span className="highlight">[Your Email]</span></p>
              <p><strong>Registered Address:</strong> <span className="highlight">[Your Address]</span></p>
            </div>

            <p className="terms-intro">
              This Privacy Policy explains how Stocks4U collects, uses, stores, shares, protects, and processes user information when users access or use our website, dashboard, tools, screeners, filters, alerts, charts, APIs, software, content, and related services.
              <br/><br/>
              By using Stocks4U, you agree to the collection and use of information in accordance with this Privacy Policy.
            </p>

            <div className="terms-body">
              <section className="terms-point">
                <h2>1. ABOUT STOCKS4U</h2>
                <p>Stocks4U is a technology-based stock market data filtering and analysis platform.</p>
                <p>Stocks4U helps users view, organize, filter, scan, and analyze market-related data through tools, dashboards, screeners, alerts, charts, watchlists, and system-generated outputs.</p>
                <p>Stocks4U is a third-party API/data-dependent technology platform. Our services may depend on third-party APIs, data vendors, brokers, exchanges, cloud providers, payment gateways, analytics tools, and other external service providers.</p>
              </section>

              <section className="terms-point">
                <h2>2. INFORMATION WE COLLECT</h2>
                <p>We may collect the following types of information from users:</p>
                <p><strong>Personal Information:</strong></p>
                <ul>
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Mobile number</li>
                  <li>Account login details</li>
                  <li>Billing information</li>
                  <li>Subscription details</li>
                  <li>Support request details</li>
                  <li>Any information voluntarily submitted by the user</li>
                </ul>
                <p><strong>Technical Information:</strong></p>
                <ul>
                  <li>IP address</li>
                  <li>Device type</li>
                  <li>Browser type</li>
                  <li>Operating system</li>
                  <li>Device identifiers</li>
                  <li>Login time</li>
                  <li>Usage logs</li>
                  <li>Pages visited</li>
                  <li>Feature usage</li>
                  <li>Crash reports</li>
                  <li>Cookies and similar tracking data</li>
                </ul>
                <p><strong>Payment Information:</strong></p>
                <ul>
                  <li>Payment status</li>
                  <li>Transaction ID</li>
                  <li>Subscription plan</li>
                  <li>Invoice details</li>
                  <li>Payment gateway response</li>
                </ul>
                <p>Stocks4U does not directly store complete card numbers, UPI PINs, net banking passwords, or sensitive payment credentials. Such payment processing may be handled by third-party payment gateways.</p>
              </section>

              <section className="terms-point">
                <h2>3. INFORMATION WE DO NOT INTENTIONALLY COLLECT</h2>
                <p>Stocks4U does not intentionally collect sensitive personal information such as:</p>
                <ul>
                  <li>Aadhaar number</li>
                  <li>PAN card details</li>
                  <li>Bank account password</li>
                  <li>Trading account password</li>
                  <li>Demat account password</li>
                  <li>UPI PIN</li>
                  <li>Card PIN</li>
                  <li>Health information</li>
                  <li>Biometric data</li>
                  <li>Religious or political information</li>
                </ul>
                <p>Users should not share such sensitive information with Stocks4U unless specifically required by law or clearly requested for a valid service purpose.</p>
              </section>

              <section className="terms-point">
                <h2>4. HOW WE USE YOUR INFORMATION</h2>
                <p>Stocks4U may use collected information for the following purposes:</p>
                <ul>
                  <li>To create and manage user accounts</li>
                  <li>To provide access to platform features</li>
                  <li>To process subscriptions and payments</li>
                  <li>To send service-related updates</li>
                  <li>To provide customer support</li>
                  <li>To improve platform performance</li>
                  <li>To personalize user experience</li>
                  <li>To monitor technical issues</li>
                  <li>To prevent fraud, misuse, or unauthorized access</li>
                  <li>To analyze usage and improve features</li>
                  <li>To comply with legal, regulatory, or security requirements</li>
                  <li>To send important notices, updates, or policy changes</li>
                </ul>
                <p>We do not sell users’ personal information to third parties.</p>
              </section>

              <section className="terms-point">
                <h2>5. THIRD-PARTY API AND DATA SERVICE DEPENDENCY</h2>
                <p>Stocks4U may use third-party services for market data, APIs, analytics, hosting, payments, communication, security, and other operational requirements.</p>
                <p>These third-party services may collect or process limited user data as required to provide their services.</p>
                <p>Third-party providers may include:</p>
                <ul>
                  <li>Market data APIs</li>
                  <li>Broker APIs</li>
                  <li>Exchange-related data providers</li>
                  <li>Payment gateways</li>
                  <li>Cloud hosting providers</li>
                  <li>Analytics tools</li>
                  <li>Email/SMS/notification providers</li>
                  <li>Security and monitoring tools</li>
                </ul>
                <p>Stocks4U is not responsible for the privacy practices, data handling, availability, pricing, policy changes, or security standards of third-party services.</p>
                <p>Users are encouraged to read the privacy policies of any third-party services they interact with.</p>
              </section>

              <section className="terms-point">
                <h2>6. COOKIES AND TRACKING TECHNOLOGIES</h2>
                <p>Stocks4U may use cookies, pixels, local storage, analytics tags, and similar technologies to:</p>
                <ul>
                  <li>Keep users logged in</li>
                  <li>Remember user preferences</li>
                  <li>Improve website performance</li>
                  <li>Analyze traffic and usage</li>
                  <li>Detect errors and technical issues</li>
                  <li>Improve security</li>
                  <li>Understand user behavior on the platform</li>
                </ul>
                <p>Users may disable cookies through browser settings. However, some features of Stocks4U may not work properly if cookies are disabled.</p>
              </section>

              <section className="terms-point">
                <h2>7. DATA SHARING AND DISCLOSURE</h2>
                <p>Stocks4U may share user information only in limited situations such as:</p>
                <ul>
                  <li>With payment gateways to process payments</li>
                  <li>With cloud providers to host services</li>
                  <li>With analytics providers to improve platform performance</li>
                  <li>With communication providers to send emails, SMS, or notifications</li>
                  <li>With support tools to resolve user queries</li>
                  <li>With legal authorities when required by law</li>
                  <li>With security partners to prevent fraud or abuse</li>
                  <li>With business partners only where necessary to operate the service</li>
                </ul>
                <p>Stocks4U does not sell, rent, or trade personal information for unauthorized commercial use.</p>
              </section>

              <section className="terms-point">
                <h2>8. PAYMENT DATA</h2>
                <p>Payments made on Stocks4U may be processed through third-party payment gateways.</p>
                <p>Stocks4U may receive limited payment-related information such as payment status, transaction ID, subscription plan, invoice details, and payment confirmation.</p>
                <p>Stocks4U does not directly store sensitive payment credentials such as full card number, CVV, UPI PIN, or banking password.</p>
                <p>Payment processing is subject to the terms and privacy policy of the respective payment gateway.</p>
              </section>

              <section className="terms-point">
                <h2>9. DATA SECURITY</h2>
                <p>Stocks4U takes reasonable technical, administrative, and organizational measures to protect user data from unauthorized access, loss, misuse, alteration, or disclosure.</p>
                <p>Security measures may include:</p>
                <ul>
                  <li>Secure server infrastructure</li>
                  <li>Access controls</li>
                  <li>Password protection</li>
                  <li>Encryption where applicable</li>
                  <li>Monitoring and logging</li>
                  <li>Limited internal access</li>
                  <li>Regular technical checks</li>
                </ul>
                <p>However, no online platform, website, API, database, or internet-based service can be guaranteed to be 100% secure.</p>
                <p>Users are responsible for keeping their login credentials confidential and should not share passwords or account access with anyone.</p>
              </section>

              <section className="terms-point">
                <h2>10. DATA RETENTION</h2>
                <p>Stocks4U may retain user information for as long as necessary to:</p>
                <ul>
                  <li>Provide services</li>
                  <li>Maintain user accounts</li>
                  <li>Process payments and invoices</li>
                  <li>Resolve disputes</li>
                  <li>Improve platform performance</li>
                  <li>Comply with legal obligations</li>
                  <li>Prevent fraud or misuse</li>
                  <li>Maintain security logs</li>
                  <li>Enforce our Terms & Conditions</li>
                </ul>
                <p>When personal data is no longer required, Stocks4U may delete, anonymize, or securely archive it, subject to applicable laws and business requirements.</p>
              </section>

              <section className="terms-point">
                <h2>11. USER RIGHTS</h2>
                <p>Subject to applicable laws, users may request:</p>
                <ul>
                  <li>Access to their personal data</li>
                  <li>Correction of incorrect personal data</li>
                  <li>Deletion of personal data</li>
                  <li>Withdrawal of consent</li>
                  <li>Account deletion</li>
                  <li>Update of account information</li>
                  <li>Grievance redressal</li>
                </ul>
                <p>Users can submit such requests by contacting us at:</p>
                <p>Email: <span className="highlight">[Your Email]</span></p>
                <p>We may verify the user’s identity before processing any privacy-related request.</p>
              </section>

              <section className="terms-point">
                <h2>12. WITHDRAWAL OF CONSENT</h2>
                <p>Users may withdraw consent for certain data processing activities by contacting Stocks4U.</p>
                <p>However, withdrawal of consent may affect access to certain features, account services, subscriptions, alerts, dashboards, or platform functionality.</p>
                <p>Stocks4U may still retain or process certain information where required for legal, security, fraud-prevention, tax, accounting, dispute-resolution, or legitimate business purposes.</p>
              </section>

              <section className="terms-point">
                <h2>13. CHILDREN’S PRIVACY</h2>
                <p>Stocks4U is not intended for users below the age of 18.</p>
                <p>We do not knowingly collect personal information from children.</p>
                <p>If we discover that a child has provided personal information without proper consent, we may delete such information and restrict account access.</p>
                <p>Users below 18 years should not use Stocks4U without appropriate parental or legal guardian supervision.</p>
              </section>

              <section className="terms-point">
                <h2>14. EMAILS, NOTIFICATIONS AND COMMUNICATION</h2>
                <p>Stocks4U may send users:</p>
                <ul>
                  <li>Account-related messages</li>
                  <li>Subscription updates</li>
                  <li>Payment confirmations</li>
                  <li>Feature updates</li>
                  <li>Security alerts</li>
                  <li>Service announcements</li>
                  <li>Support replies</li>
                  <li>Policy updates</li>
                  <li>Marketing or promotional communication</li>
                </ul>
                <p>Users may unsubscribe from marketing communication where such option is available.</p>
                <p>However, important service, payment, legal, or security-related messages may still be sent.</p>
              </section>

              <section className="terms-point">
                <h2>15. ANALYTICS AND PERFORMANCE MONITORING</h2>
                <p>Stocks4U may use analytics and monitoring tools to understand platform usage, detect errors, improve user experience, and maintain service quality.</p>
                <p>Analytics data may include pages visited, features used, session duration, device type, browser type, crash logs, and general usage patterns.</p>
                <p>This information helps us improve Stocks4U’s performance, reliability, and design.</p>
              </section>

              <section className="terms-point">
                <h2>16. THIRD-PARTY LINKS</h2>
                <p>Stocks4U may contain links to third-party websites, APIs, brokers, payment gateways, data providers, or external platforms.</p>
                <p>We are not responsible for the privacy practices, content, policies, or security of third-party websites or services.</p>
                <p>Users should review the privacy policies of third-party platforms before sharing any information with them.</p>
              </section>

              <section className="terms-point">
                <h2>17. DATA TRANSFER</h2>
                <p>Stocks4U may use cloud services, APIs, hosting providers, or third-party tools located in India or outside India.</p>
                <p>By using Stocks4U, users agree that their information may be processed, stored, or transferred through service providers as required for platform operations, subject to applicable laws.</p>
              </section>

              <section className="terms-point">
                <h2>18. BUSINESS TRANSFER</h2>
                <p>If Stocks4U is involved in a merger, acquisition, restructuring, sale of assets, partnership, investment, or business transfer, user information may be transferred as part of the business assets.</p>
                <p>In such cases, Stocks4U will take reasonable steps to ensure that user information remains protected.</p>
              </section>

              <section className="terms-point">
                <h2>19. LEGAL COMPLIANCE</h2>
                <p>Stocks4U may disclose or process user information if required to:</p>
                <ul>
                  <li>Comply with applicable laws</li>
                  <li>Respond to legal requests</li>
                  <li>Follow court orders</li>
                  <li>Cooperate with government or regulatory authorities</li>
                  <li>Investigate fraud, misuse, or security incidents</li>
                  <li>Protect the rights, property, or safety of Stocks4U, users, or others</li>
                  <li>Enforce our Terms & Conditions</li>
                </ul>
              </section>

              <section className="terms-point">
                <h2>20. DATA BREACH</h2>
                <p>In case of a data breach or security incident affecting user information, Stocks4U will take reasonable steps to investigate, contain, and resolve the issue.</p>
                <p>Where required by applicable law, Stocks4U may notify affected users and/or relevant authorities.</p>
              </section>

              <section className="terms-point">
                <h2>21. USER RESPONSIBILITY</h2>
                <p>Users are responsible for:</p>
                <ul>
                  <li>Providing accurate information</li>
                  <li>Keeping login credentials secure</li>
                  <li>Using strong passwords</li>
                  <li>Not sharing account access</li>
                  <li>Logging out from shared devices</li>
                  <li>Avoiding suspicious links or phishing attempts</li>
                  <li>Updating contact details</li>
                  <li>Reviewing privacy settings where available</li>
                </ul>
                <p>Stocks4U shall not be responsible for losses caused by user negligence, shared passwords, compromised devices, or unauthorized access due to user-side security failure.</p>
              </section>

              <section className="terms-point">
                <h2>22. CHANGES TO THIS PRIVACY POLICY</h2>
                <p>Stocks4U may update this Privacy Policy from time to time.</p>
                <p>Updated versions will be posted on the website or app with a revised Effective Date.</p>
                <p>Continued use of Stocks4U after changes means users accept the updated Privacy Policy.</p>
                <p>Users are advised to review this Privacy Policy periodically.</p>
              </section>

              <section className="terms-point">
                <h2>23. CONTACT AND GRIEVANCE REDRESSAL</h2>
                <p>For privacy-related questions, data requests, complaints, or grievance redressal, users may contact:</p>
                <p>Email: <span className="highlight">[Your Email]</span></p>
                <p>Company Name: <span className="highlight">[Your Company Name]</span></p>
                <p>Address: <span className="highlight">[Your Address]</span></p>
                <p><br/></p>
                <p>Grievance Officer / Contact Person: <span className="highlight">[Name, if applicable]</span></p>
                <p>Email: <span className="highlight">[Grievance Email]</span></p>
                <p>Response Time: <span className="highlight">[Mention expected response time, e.g., within 30 days or as required by applicable law]</span></p>
              </section>

              <section className="terms-point">
                <h2>24. FINAL PRIVACY STATEMENT</h2>
                <p>Stocks4U respects user privacy and aims to handle personal information responsibly.</p>
                <p>We collect only such information that is reasonably required to operate, improve, secure, and provide our services.</p>
                <p><strong>By using Stocks4U, you confirm that you have read, understood, and agreed to this Privacy Policy.</strong></p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
